export const ACTIVE_SCREEN_KEY = 'activeScreen';

export const ASOI_PLATFORM_APP_ID = 'asio_platform';

export const DEFAULT_ROLES = {
    Admin: 'Admin',
    BillingAdmin: 'Billing Admin',
    UserManagement: 'User Management',
    HomeAdmin: 'Home Admin',
    HomeAdvancedUser: 'Home Advanced User',
    HomeStandardUser: 'Home Standard User',
    HomeBasicUser: 'Home Basic User',
    HomeRestrictedUser: 'Home Restricted User',
};

export const LOCAL_LOGIN = 'Local Login';

export default DEFAULT_ROLES;

export const EMAIL_MFA = 'emailMfa';
export const AUTH_APP_MFA = 'authAppMfa';
export const DUO_MFA = 'duoMfa';
export const HOST = 'host';
export const CLIENT_ID = 'clientId';
export const NAME = 'name';
export const DESCRIPTION = 'description';
export const MFA_DETAILS = 'mfaDetails';
export const DUO_MFA_DETAILS = 'duoMfaDetails';
export const ISDUO_USERNAME_SAME_AS_LOGIN_EMAIL = 'isDuoUsernameSameAsLoginEmail';
export const AUTHENTICATION_FILTER = 'authenticationFilter';
export const MFA_FILTER = 'mfaFilter';
export const ACTION = {
    TYPE_ARRAY: 'toArray',
    TYPE_DEFAULT: 'default',
    TYPE_MAP: 'toMap',
};

// list of app role ids specific to home
export const appRoles = {
    ADMIN: 'Admin',
    USER_MANAGEMENT: 'User Management',
    FULL_ADMIN: 'User Management - Full Admin',
};

export const PERMISSIONS = {
    USERS_CREATE: 'users.create',
    USERS_ROLES_VIEW: 'users.roles.view',
    USERS_ROLES_UPDATE: 'users.roles.update',
    USERS_ENABLE: 'users.enable',
    USERS_EMAIL_RESEND: 'users.email.resend',
    ROLES_CREATE: 'roles.create',
    USERS_DELETE: 'users.delete',
    USERS_VIEW: 'users.view',
    USERS_UPDATE: 'users.update',
    USERS_EXPORT: 'users.export',
    USERS_PASSWORD_RESET: 'users.password.reset',
    USERS_APPROVAL_ALL: 'users.approval.all',
    ROLES_VIEW: 'roles.view',
    ROLES_UPDATE: 'roles.update',
    ROLES_DELETE: 'roles.delete',
    AUTHENTICATION_CREATE: 'authentication.create',
    AUTHENTICATION_VIEW: 'authentication.view',
    AUTHENTICATION_UPDATE: 'authentication.update',
    AUTHENTICATION_DELETE: 'authentication.delete',
    AUTHENTICATION_ENABLE: 'authentication.enable',
    AUTHENTICATION_TOKEN_GENERATE: 'authentication.token.generate',
    USERS_AUTH_VIEW: 'users.auth.view',
    USERS_AUTH_UPDATE: 'users.auth.update',
    APPLICATION_ROLES_VIEW: 'roles.application.view',
    APPLICATION_ROLES_UPDATE: 'roles.application.all',
    NOTIFICATION_ALL: 'notification.all',
};

// list of all available permissions
export const IAM_SSO_PERMISSIONS = [
    'users.view',
    'users.create',
    'users.update',
    'users.delete',
    'users.enable',
    'users.export',
    'users.password.reset',
    'users.email.resend',
    'users.auth.view',
    'users.auth.update',
    'users.roles.view',
    'users.roles.update',
    'users.approval.all',
    'roles.view',
    'roles.create',
    'roles.update',
    'roles.delete',
    'roles.application.all',
    'authentication.create',
    'authentication.view',
    'authentication.update',
    'authentication.delete',
    'authentication.token.generate',
    'authentication.enable',
    'products.all',
    'notification.all',
    'roles.application.view',
];

export const SUPPORT_LINK = 'https://home.connectwise.com/partnersupport';
